/* eslint-disable no-restricted-globals */
import { useNavigate } from "react-router-dom";
import { formatUserProfile, setRedirectPath } from "../utils";
import { useAuthContext } from "./useAuthContext";
/**
 * Hook for managing OneLogin authentication flow
 *
 * @copyright 2021 Noom, Inc.
 * @author nikola
 */
export function useAuth() {
    var _a;
    const navigate = useNavigate();
    const { isAuthenticated, state: authState, error: authError, inProgress, shouldReLogin: shouldReLoginFromContext, } = (_a = useAuthContext()) !== null && _a !== void 0 ? _a : {};
    const shouldReLogin = () => {
        if (!shouldReLoginFromContext) {
            throw new Error("Missing context!");
        }
        return shouldReLoginFromContext();
    };
    /** Restart the login flow */
    const reLogin = (loginPath = "/login") => {
        setRedirectPath(location);
        navigate(loginPath);
    };
    return {
        isAuthenticated: Boolean(isAuthenticated),
        state: authState,
        reLogin,
        shouldReLogin,
        error: authError,
        inProgress,
        isLoading: inProgress,
        user: authState ? formatUserProfile(authState) : undefined,
    };
}
//# sourceMappingURL=useAuth.js.map